function PromoPopup(el) {
		var HIDDEN_CLASS = 'promo-popup__hidden';
		var POPUP_OVERLAY_SELECTOR = '.js-promo-popup-overlay';
		var BUTTON_CLOSE_POPUP_SELECTOR = '.js-promo-popup-close';
		var SHOW_POPUP = false;
		var POPUP_OPEN_TIME = null;

		var checkPopupClosed = localStorage.getItem('closedPopup');

		if (checkPopupClosed) {
				el.classList.add(HIDDEN_CLASS);
		}

		// Delay 3 seconds because it's delayed in CSS
		setTimeout(function () {
			SHOW_POPUP = checkPopupClosed === null;
			POPUP_OPEN_TIME = new Date();
		}, 3000);

		var closePromoPopup = function () {
			if (!SHOW_POPUP) { return false; }
				el.classList.add(HIDDEN_CLASS);
				localStorage.setItem('closedPopup', true);
				var now = new Date();
				var visibleTime = (now - POPUP_OPEN_TIME) / 1000;
				if (SHOW_POPUP && visibleTime) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'promo_popup_visible_time': visibleTime});
				}
		};

		var popupOverlayElm = document.querySelector(POPUP_OVERLAY_SELECTOR);

		if (popupOverlayElm) {
				popupOverlayElm.addEventListener('click', function () {
						closePromoPopup();
				});
		}

		var buttonClosePopup = document.querySelector(BUTTON_CLOSE_POPUP_SELECTOR);
		if (buttonClosePopup) {
				buttonClosePopup.addEventListener('click', function () {
						closePromoPopup();
				});
		}

}

module.exports = PromoPopup;
